export default __webpack_public_path__ + "static/media/i169vp.2852c9b4.webp";